import React from "react"
import {Card, Icon, Image, Item, Segment} from "semantic-ui-react"
import {Link} from "react-router-dom"
import _ from "lodash"
import docImage from "../doc.png"

const Title = ({ children, className }) => (
  <div className={`f4 ${className}`}>{children}</div>
)

const Document = ({ document, step }) => {
  if ( document.FileName && document.FileName.includes( "Unterschrift" ) ) return null
  return (
    <Card>
      {(document.ContentType && _.includes( document.ContentType, "image/" )) ?
        <Image src={document.URI} href={document.URI} target="_blank"/> :
        <Icon size="large" name="file outline" href={document.URI} target="_blank"/>}
      <Card.Content>
        <Card.Header>
          {document.FileName}
        </Card.Header>
        <Card.Meta>
          { step ? <Link to={`/tasks/${step.Id}`}>{`#${step.SortOrder}. ${step.Name}`}</Link> : null }
        </Card.Meta>
      </Card.Content>
    </Card>
  )
}

const ItemDocument = ({ document } = {}) => {
  if ( document.FileName && document.FileName.includes( "Unterschrift" ) ) {
    return <Image style={{ pointerEvents: "none" }} size="tiny"
                  src={document.ThumbURI || document.URI}/>
  }
  return (
    <Item>
      {(document.ThumbURI || document.ContentType === "image/jpeg" || document.ContentType === "image/png" ||
      document.ContentType === "image/jpg" ) ?
        <Image size="tiny" src={document.ThumbURI || document.URI} href={document.URI} target="_blank"/> :
        <Image size="tiny" src={docImage} href={document.URI} target="_blank"/>}
      <Item.Content>
        <a className="f5 black-50" target="_blank" href={document.URI}> {document.FileName}</a>
        <Item.Meta><span className="f5 black-50">{document.ContentType}</span></Item.Meta>
      </Item.Content>
    </Item>
  )
}

const DocumentSmall = ({ document, step, isDownloadable }) => {
  if ( document.FileName && document.FileName.includes( "Unterschrift" ) ) return null
  return (
    <Segment>
      <h2>{isDownloadable ? <a href={document.URI}>{document.FileName}</a> : <span>{document.FileName}</span>}</h2>
      <div>
        { step ? <Link to={`/tasks/${step.Id}`}>{`#${step.SortOrder}. ${step.Name}`}</Link> : null }
      </div>
    </Segment>
  )
}

const Info = ({ children }) => (
  <Segment basic className="white">{children}</Segment>
)

//
// <Image src="/paragraph.png">
//   <div className="f3 ">{title}<Button className="fr" size="small"><Icon name="download"/> PDF</Button>
// </div>
// </Image>

const MFR = {
  Title, Document, DocumentSmall, Info, ItemDocument
}

export default MFR



// WEBPACK FOOTER //
// ./src/presentation/MFR.js